<template>
  <Dialog v-model:visible="visible" modal :draggable="false" :closable="false" style="min-width: 720px">
    <template #header>
      <h2>Sync IAP</h2>
    </template>
    <p>Are you sure you want to unlink this IAP from its Pricing Template?</p>
    <div :class="$style.formButtons">
      <Button type="button" label="Continue" :loading="loading" @click="onConfirm" />
      <Button type="button" label="Cancel" severity="secondary" :disabled="loading" @click="onCancel()" />
    </div>
  </Dialog>
</template>

<script setup>
import { Button, Dialog } from "primevue";
import { defineEmits, defineModel, ref } from "vue";
import useToast from "@/hooks/useToastNotification";
import usePricingTemplates from "@/modules/IAP/hooks/usePricingTemplates";

const { unlinkPricingTemplateFromIAP } = usePricingTemplates();
const { toastSuccess } = useToast();
const iap = defineModel();
const emit = defineEmits(["submit"]);

const visible = defineModel("visible");
const loading = ref(false);

const onConfirm = async () => {
  loading.value = true;
  if (
    await unlinkPricingTemplateFromIAP(
      iap.value.appId,
      iap.value.pricingTemplateLink[0].pricingTemplateId,
      iap.value.id
    )
  ) {
    toastSuccess({
      detail: `Successfully unlinked IAP ${iap.value.name} from ${iap.value.pricingTemplateLink[0].pricingTemplate.name}!`,
      summary: "Success!",
      life: 5000,
    });
  }
  loading.value = false;
  visible.value = false;
  emit("submit");
};

function onCancel() {
  visible.value = false;
}
</script>

<style module>
.formButtons {
  display: flex;
  gap: 8px;
  flex-direction: row-reverse;
}
</style>
